import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  label: string;
}

export const Warning: React.FC<Props> = ({ label }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={1} flexWrap="nowrap" alignItems="center" sx={{ overflow: 'hidden' }}>
      <WarningAmberOutlined sx={{ fill: theme.palette.warning.main, flexShrink: 0 }} fontSize="small" />
      <Typography noWrap variant="caption" color="textPrimary" sx={{ minWidth: 0 }}>
        {label}
      </Typography>
    </Stack>
  );
};

export const WarningCell: React.FC<Props> = (props) => (
  <Box height="100%" display="flex" alignItems="center">
    <Warning {...props} />
  </Box>
);
